import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shouldAutoAdvanceWhenLabelsComplete: {
    id: `app.containers.WorkflowEditor.components.StageDetail.settingsSwitches.messages.shouldAutoAdvanceWhenLabelsComplete`,
    defaultMessage:
      'Automatically move applicant to next stage when all labels are completed',
  },
  goEnabled: {
    id: `app.containers.WorkflowEditor.components.StageDetail.settingsSwitches.messages.goEnabled`,
    defaultMessage: 'Show stage in Hire Go',
  },
  allowRejectInHireGo: {
    id: `app.containers.WorkflowEditor.components.StageDetail.settingsSwitches.messages.allowRejectInHireGo`,
    defaultMessage: 'Allow "Reject" from Hire Go',
  },
});
